var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Container, ProgressBar } from "@animech/ui";
import { useTranslation } from "react-i18next";
import { CustomBaseModal } from "ui/components/modals/custom-base-modal/custom-base-modal";
export var LoadingModal = function (_a) {
    var translationKey = _a.translationKey, props = __rest(_a, ["translationKey"]);
    var t = useTranslation().t;
    return (_jsx(CustomBaseModal, __assign({}, props, { title: t(translationKey), color: "inverted", hideCloseButton: true, children: _jsx(Container, { children: _jsx(ProgressBar, {}) }) })));
};
